import { useMemo } from "react";
import { TreeNode } from ".";
import { StepItem } from "~/components/build/Show/routes/steps/list/-components/TreeNode/StepItem";
import { STEP_ITEM_HEIGHT } from "~/components/build/Show/routes/steps/list/-components/constants";
import useCurrentJobOrStep from "~/components/build/Show/lib/useCurrentJobOrStep";
import { CommandStep, isFailed } from "~/lib/pipeline";
import useQueryParams from "~/components/build/Show/lib/useQueryParams";

interface Props {
  step: CommandStep;
  depth?: number;
}

export function CommandStepItem(props: Props) {
  const { currentStep } = useCurrentJobOrStep();
  const params = useQueryParams();

  const active = useMemo(
    () =>
      props.step.uuid === currentStep?.uuid ||
      (Boolean(params.jid) && props.step.statistics?.latestJobId === params.jid),
    [props.step.uuid, props.step.statistics?.latestJobId, currentStep?.uuid, params.jid],
  );

  return <StepItem {...props} active={active} failed={isFailed(props.step)} />;
}

export const createCommandStepNode = (step: CommandStep): TreeNode => ({
  id: step.uuid,
  height: STEP_ITEM_HEIGHT,
  render: ({ depth }) => <CommandStepItem step={step} depth={depth} />,
});
